import React from 'react';
import Button from '../../setup_viewer/components/extras/button';
import WasmChangeSummary from '../wasm_changes_summary';
import { Verbiage } from '../verbiage.constants';

function ModelChangesModal(props) {
  const { close, tmt, ipr, revision_note } = props;

  return (
    <div>
      <div className="modal-title">{Verbiage.ChangesModal.Title}</div>
      <div className="modal-body-paragraph">
        <WasmChangeSummary tmt={tmt} ipr={ipr} revision_note={revision_note} />
      </div>
      <div className="modal-button-group">
        <Button theme="secondary_outline" onClick={close}>
          {Verbiage.ChangesModal.CloseBtn}
        </Button>
      </div>
    </div>
  );
}

export default ModelChangesModal;
